module.exports = __webpack_public_path__ + "static/media/home_approve_event.7f210cfa.jpg";